import {
  Typography
} from '@mui/material';
import {
  Component
} from "react";
import {
  sanitizeArr
} from '../../lib/Array.lib';
import Core from "../../lib/Core";
import Definition from "../../lib/Definition";
import {
  COLLECTION__DEFINITIONS,
  readLoopbackRecord
} from '../../lib/services/BE/loopback.api';
import Store from "../../lib/Store";
import {
  joinKeyName,
  trim
} from '../../lib/String.lib';
import {
  getLocation
} from '../../lib/URL.lib';
import Divider from '../Layout/Wrappers/Divider';
import Paper, {
  getDefaultPaperStyle
} from '../Layout/Wrappers/Paper';
import CategoryBox from "./CategoryBox";
import TagBox from "./TagBox";

export default class TagManagement extends Component {
  constructor() {
    super(...arguments);
    this.state = { categories: [] };
    Store.set("path", getLocation());
    this.load();
  }
  load() {
    readLoopbackRecord({
      collection: COLLECTION__DEFINITIONS
    }).then(definitions => {
      console.debug({ definitions });
      this.setState(
        state => {
          const categories = sanitizeArr(definitions)
            .map(item => ({
              ...item,
              normalizedKey: trim(item.key),
            }))
            .sort((a, b) => a.normalizedKey.localeCompare(b.normalizedKey));

          const keyCount = categories.reduce((acc, item) => {
            acc[item.normalizedKey] = (acc[item.normalizedKey] || 0) + 1;
            return acc;
          }, {});

          state.categories = categories.map(item => ({
            ...item,
            duplicated: keyCount[item.normalizedKey] > 1,
          }));

          return state;
        },
        then => window.scrollTo(0, 0)
      );
    });
  }
  render() {
    console.debug(
      'TagManagement...',
      '\n', this.state,
    );
    return (
      <Paper
        className='m-auto my-2 scroll-y'
        style={getDefaultPaperStyle({ maxHeight: 'calc(100% - 3rem)' })}
      >
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} className='c-purple m-0 p-2'>
          Tag management
        </Typography>
        <Divider />
        {this.state.categories.map((category, catIndex) => (
          <CategoryBox
            key={joinKeyName([
              'TagManagement__CategoryBox',
              category.id,
              category.key
            ])}
            category={category}
            tags={category.values}
            onUpdate={({ category, tags }) => {
              console.debug('tags', tags);
              this.setState(async state => {
                if (category) {
                  const update = {
                    key: category.key,
                    label: category.label,
                    archived: category.archived,
                    groups: category.groups
                  };
                  state.categories[catIndex] = category;
                  await Definition.update(category.id, update);
                }
                if (tags) {
                  const update = {
                    values: tags
                  };
                  state.categories[catIndex].values = tags;
                  await Definition.update(category.id, update);
                }
                console.debug(
                  'TagManagement__CategoryBox__onUpdate...',
                  '\n', category,
                  '\n', tags,
                  '\n', state,
                );
                return state;
              });
            }}
          />
        ))}
        <div className='bg-main w-100 p-1'>
          <TagBox
            key={Core.getKey()}
            name="addNewCategory"
            placeholder="Add a New Category"
            onUpdate={tag => {
              Core.log({ tag });
              Definition.post({ label: tag.label }, res => this.load());
            }}
            new={true}
            divider={false}
          />
        </div>
      </Paper>
    );
  }
}
